import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import CookieModule from 'components/cookie-module';
import reportWebVitals from './reportWebVitals';

const mountCookieOnce = () => {
    if (document.getElementById('erz-cookie-root')) return

    const el = document.createElement('div')
    el.id = 'erz-cookie-root'
    document.body.appendChild(el)
    ReactDOM.createRoot(el).render(<CookieModule />)
}

const isLocalDev = /localhost/.test(window.location.origin)

// На встраиваемых страницах (Tilda и др.) не трогаем layout html/body —
// иначе при открытии popup высота документа схлопывается до 100vh.
const markEmbedMode = (params) => {
    if (!params.full) {
        document.documentElement.classList.add('erz-form-embed')
    }
}

const mountInstance = (mountEl, params, wrapperEl) => {
    if (mountEl.dataset.erzMounted) return

    markEmbedMode(params)
    mountEl.dataset.erzMounted = 'true'
    mountEl.classList.add('erz-form-root')

    ReactDOM.createRoot(mountEl).render(
        <App params={params} containerEl={mountEl} wrapperEl={wrapperEl} />
    )
}

const mountForms = () => {
    const wrappers = document.querySelectorAll('[data-params]')

    if (wrappers.length === 0) {
        const mountEl = document.getElementById('root')
        if (mountEl) {
            mountInstance(mountEl, isLocalDev ? { full: true } : {}, mountEl.parentElement)
        }
        return
    }

    wrappers.forEach((wrapper) => {
        const mountEl = wrapper.querySelector('.erz-form-root') || wrapper.querySelector('#root')
        if (!mountEl) return

        const params = JSON.parse(wrapper.getAttribute('data-params') || '{}')
        mountInstance(mountEl, params, wrapper)
    })
}

mountForms()
mountCookieOnce()

reportWebVitals();
